// Import utilities
const {
	isDefined
} = _uo.utility;

/**
 * Returns the integration icon
 *
 * @param {Object} options                 The options
 * @param {String} options.integrationCode The integration code
 * @return {String}                        The integration icon
 */
const getIntegrationIconURL = ( { integrationCode } ) => {
	// Default response
	let imageUrl = '';

	// Check if the integration exists
	if ( isDefined( UncannyAutomator.integrations[ integrationCode ] ) ) {
		const integration = UncannyAutomator.integrations[ integrationCode ];

		// Check if the SVG icon is defined
		if ( isDefined( integration.icon_svg ) ) {
			imageUrl = integration.icon_svg;
		} else if ( isDefined( integration.icon_64 ) ) {
			imageUrl = integration.icon_64;
		}
	}

	return imageUrl;
};

export default getIntegrationIconURL;
